import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IxDropdownButton, IxDropdownItem, IxMenuSettingsItem } from '@siemens/ix-angular/standalone';
import { SettingsService } from './settings.service';
import { UpperCasePipe } from '@angular/common';

@Component({
  selector: 'settings',
  imports: [TranslateModule, IxMenuSettingsItem, IxDropdownButton, IxDropdownItem, UpperCasePipe],
  template: `
      <ix-menu-settings-item [label]="'NAVIGATION.SETTINGS' | translate">
        <div class="settings-item">
          {{'SETTINGS.LANGUAGE_SWITCH' | translate}}
          <ix-dropdown-button
            ghost
            id="languageDropdown"
            variant="primary"
            [label]="'LANGUAGE.' + settingsService.currentLanguage() | uppercase | translate"
          >
            @for (language of settingsService.availableLanguages; track
            language) {
            <ix-dropdown-item
              [label]="'LANGUAGE.' + language | uppercase | translate"
              (click)="settingsService.setLanguage(language)"
            />
            }
          </ix-dropdown-button>
        </div>
      </ix-menu-settings-item>
  `,
  styleUrl: './settings.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SettingsComponent {
  readonly settingsService = inject(SettingsService);
}
